import { render, staticRenderFns } from "./selectRole.vue?vue&type=template&id=bf9d656a&scoped=true"
import script from "./selectRole.vue?vue&type=script&lang=js"
export * from "./selectRole.vue?vue&type=script&lang=js"
import style0 from "./selectRole.vue?vue&type=style&index=0&id=bf9d656a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9d656a",
  null
  
)

export default component.exports